import 'bootstrap/dist/css/bootstrap.min.css';
import { RotatingLines } from 'react-loader-spinner';

export const Spinner = () => {
  return (
    <div className="spinner-container">
      <RotatingLines
        strokeColor="grey"
        strokeWidth="5"
        animationDuration="0.75"
        width="96"
        visible={true}
      />
    </div>
  );
};

export default Spinner;
